import { render, staticRenderFns } from "./SelfPageReply.vue?vue&type=template&id=5b6aef09&scoped=true&"
import script from "./SelfPageReply.vue?vue&type=script&lang=js&"
export * from "./SelfPageReply.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=5b6aef09&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6aef09",
  null
  
)

export default component.exports